const MIN_MEGABYTES_NEEDED_TO_STORE_STREAM_CONTENT = 5000; // 5 GB
const ALL_CONTENT_STORED = 'all content stored for stream';

export { MIN_MEGABYTES_NEEDED_TO_STORE_STREAM_CONTENT, ALL_CONTENT_STORED };
